import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          © {currentYear} TJ's Fantasy Baseball
        </div>

        <div className="footer-links">
          <a href="#terms" className="footer-link" onClick={(e) => { e.preventDefault(); alert('Terms & Conditions coming soon'); }}>
            Terms
          </a>
          <a href="#privacy" className="footer-link" onClick={(e) => { e.preventDefault(); alert('Privacy Policy coming soon'); }}>
            Privacy
          </a>
          <a href="#about" className="footer-link" onClick={(e) => { e.preventDefault(); alert('About coming soon'); }}>
            About
          </a>
          <a href="#support" className="footer-link" onClick={(e) => { e.preventDefault(); alert('Support coming soon'); }}>
            Support
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
